// extracted by mini-css-extract-plugin
module.exports = {"root":"checkbox_root__YHTJt cursor-pointer","input":"checkbox_input__67kUH","icon":"checkbox_icon__ww13G pointer-events-none mr-2.5","label":"checkbox_label__pLex4 cursor-pointer"};